

const GTM = process.env.REACT_APP_GTM_CONTAINER

function parseProduct( product ) {
  return {                        //  adding a product to a shopping cart.
    'name':     product.title,
    'id':       `${product.article_nr}`,
    'price':    product.price,
    'brand':    product.brand,
    'category': product.category && product.category.title,
    'variant':  product.variant,
    'quantity': product.count
  }
}


class Track {

  static purchase( { order, products } ) {
    if ( !GTM ) return
    console.log( "TRACK purchase", { order, products } )
    window.dataLayer && window.dataLayer.push( {
      'event':         'purchase',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id':          order.id,                         // Transaction ID. Required for purchases and refunds.
            'affiliation': 'Online Store',
            'revenue':     order.netto,                     // Total transaction value (incl. tax and shipping)
            'tax':         '0',
            'shipping':    '0',
          },
          'products':     products.map( parseProduct )
        }
      }
    } );
  }

  static checkout( { products, step = 1, option = "" } ) {
    if ( !GTM ) return
    console.log( "TRACK checkout", { products } )
    window.dataLayer && window.dataLayer.push( {
      'event':         'checkout',
      'ecommerce':     {
        'checkout': {
          'actionField': { 'step': step, 'option': option },
          'products':    products.map( parseProduct )
        }
      }
    } );
  }


  static viewDetails( { product, list } ) {
    if ( !GTM ) return
    console.log( "TRACK viewDetails", { product } )
    window.dataLayer && window.dataLayer.push( {
      'event':     'viewDetail',
      'ecommerce': {
        'detail': {
          'actionField': { 'list': `${list ? list : ""}` },    // 'detail' actions have an optional list property.
          'products':    [ parseProduct( product ) ]
        }
      }
    } )
  }

  static removeProduct( { product } ) {
    if ( !GTM ) return
    console.log( "TRACK removeProduct", { product } )

    window.dataLayer && window.dataLayer.push( {
      'event':     'removeFromCart',
      'ecommerce': {
        'currencyCode': 'EUR',
        'remove':       {                                // 'add' actionFieldObject measures.
          'products': [ parseProduct( product ) ]
        }
      }
    } );

  }

  static addProduct( { product } ) {
    if ( !GTM ) return
    // console.log( "TRACK addProduct", { product } )

    window.dataLayer && window.dataLayer.push( {
      'event':     'addToCart',
      'ecommerce': {
        'currencyCode': 'EUR',
        'add':          {                                // 'add' actionFieldObject measures.
          'products': [ {                        //  adding a product to a shopping cart.
            'name':     product.title,
            'id':       `${product.article_nr}`,
            'price':    product.price,
            'brand':    product.brand,
            'category': product.category && product.category.title,
            'variant':  product.variant,
            'quantity': product.count
          } ]
        }
      }
    } );

    // window.ga( 'gtm1.ec:addProduct', {               // Provide product details in a productFieldObject.
    //   'id':         'P12345',                   // Product ID (string).
    //   'name':       'Android Warhol T-Shirt', // Product name (string).
    //   'category':   'Apparel',            // Product category (string).
    //   'brand':      'Google',                // Product brand (string).
    //   'variant':    'Black',               // Product variant (string).
    //   'position':   1,                    // Product position (number).
    //   'dimension1': 'Member'            // Custom dimension (string).
    // } );
    // window.ga( 'gtm1.ec:setAction', 'add' );
    // window.ga( 'gtm1.send', 'event', 'UX', 'click', 'add to cart' );
  }

}


export default Track


// WEBPACK FOOTER //
// ./src/shop/track.js